// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kOTR7","rootMobile":"styles_rootMobile__ijI0M"};